import { render, staticRenderFns } from "./AccountFormRecordType.vue?vue&type=template&id=4ba37145&scoped=true&"
import script from "./AccountFormRecordType.vue?vue&type=script&lang=ts&"
export * from "./AccountFormRecordType.vue?vue&type=script&lang=ts&"
import style0 from "./AccountFormRecordType.vue?vue&type=style&index=0&id=4ba37145&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba37145",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
